if(typeof empty === 'undefined') {var e = new Error("Cannot find module 'empty'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = empty;